import React from 'react';
import * as LayoutPages from '../../apps/Layout/Pages';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from '../../provider/useAuth';
import './general.scss';
import NavbarCollapse from './../../components/Navbar/NavbarCollapse';
import { useSidebar } from '../../provider/SidebarProvider';

const PrivateRoutes = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { isCollapsed } = useSidebar();

  React.useEffect(() => {
    if (!currentUser) {
      navigate('/auth/select-role');
    }
  }, [currentUser, navigate]);

  return (
    <>
      <div className={`general-container ${isCollapsed ? 'collapsed' : ''}`}>
        <div className='content-wrapper'>
          <NavbarCollapse />
        </div>
        <Routes>
          <Route
            index
            element={<LayoutPages.Profile pageTitle='Профиль' />}
          />
          <Route
            path='dashboard'
            element={<LayoutPages.Dashboard pageTitle='Статистика' />}
          />
          <Route
            path='search'
            element={<LayoutPages.Search pageTitle='Искать везде' />}
          />
          <Route
            path='allOrders'
            element={<LayoutPages.AllOrders pageTitle='Все заказы' />}
          />
          <Route
            path='orders'
            element={<LayoutPages.Orders pageTitle='Активные заказы в реальном времени' />}
          />
          <Route
            path='returned-orders'
            element={<LayoutPages.ReturnedOrders pageTitle='Список возвратов' />}
          />
          <Route
            path='order/returned/details/:id'
            element={<LayoutPages.ReturnedOrderDetail pageTitle='Детали возврата' />}
          />
          <Route
            path='orderss'
            element={<LayoutPages.Orderss pageTitle='Активные заказы' />}
          />
          <Route
            path='order/print'
            element={<LayoutPages.PrintOrders pageTitle='Заказы на печать' />}
          />
          <Route
            path='couriersOrders'
            element={<LayoutPages.CouriersOrders pageTitle='Активные заказы (курьеры)' />}
          />
          <Route
            path='couriersDoneOrders'
            element={<LayoutPages.CourierDoneOrders pageTitle='Завершенные заказы (курьеры)' />}
          />
          <Route
            path='order/edited'
            element={<LayoutPages.EditedOrders pageTitle='Список измененных заказов' />}
          />
          <Route
            path='order/completed'
            element={<LayoutPages.CompletedOrders pageTitle='Список завершенных заказов' />}
          />
          <Route
            path='order/completed/details/:id'
            element={<LayoutPages.CompletedOrderDetail pageTitle='Детали завершенных заказов' />}
          />
          <Route
            path='order/cancelled'
            element={<LayoutPages.CancelledOrders pageTitle='Список отмененных заказов' />}
          />
          <Route
            path='order/deleted'
            element={<LayoutPages.DeletedOrders pageTitle='Список удаленных заказов' />}
          />
          <Route
            path='order/cancelled/details/:id'
            element={<LayoutPages.CanceledOrdersDetail pageTitle='Детали отменненого заказа' />}
          />
          <Route
            path='longorders'
            element={<LayoutPages.LongOrders pageTitle='Список долгих заказов' />}
          />
          <Route
            path='schetFaktura'
            element={<LayoutPages.OrderShetFaktura pageTitle='Список заказов (Счет фактура)' />}
          />
          <Route path='order/debt'
            element={<LayoutPages.OrdersDebt pageTitle='Список долгов' />}
          />
          <Route
            path='order/add'
            element={<LayoutPages.AddOrder pageTitle='Добавить заказ' />}
          />
          <Route
            path='order/details/:id'
            element={<LayoutPages.OrderDetail pageTitle='Детали заказа' />}
          />
          <Route
            path='order/update/:id'
            element={<LayoutPages.EditOrder pageTitle='Редактирование заказа' />}
          />
          <Route
            path='order/history/:collectionId/:id'
            element={<LayoutPages.History pageTitle='История заказа' />}
          />

          <Route
            path='order/notes/:id'
            element={<LayoutPages.Notes pageTitle='Заметки заказа' />}
          />
          <Route
            path='userHistory/:role/:id'
            element={<LayoutPages.UserHistory pageTitle='История пользователя' />}
          />
          <Route
            path='clients'
            element={<LayoutPages.Clients pageTitle='Список клиентов' />}
          />
          <Route
            path='client/details/:id'
            element={<LayoutPages.ClientDetail pageTitle='Детали клиента' />}
          />
          <Route
            path='courier/add'
            element={<LayoutPages.AddCourier pageTitle='Добавить курьера' />}
          />
          <Route
            path='couriers'
            element={<LayoutPages.Couriers pageTitle='Список курьеров' />}
          />
          <Route
            path='couriersBishkek'
            element={<LayoutPages.Couriers pageTitle='Список курьеров' mode='bishkek' />}
          />
          <Route
            path='couriersTest2'
            element={<LayoutPages.CouriersTest2 pageTitle='Список курьеров (ТЕСТ)' />}
          />
          <Route
            path='couriersTest2/details/:id'
            element={<LayoutPages.CouriersTest2Detail pageTitle='Детали курьера (ТЕСТ)' />}
          />
          <Route
            path='courier/map'
            element={<LayoutPages.CourierMap pageTitle='Карта курьеров' />}
          />
          <Route
            path='courier/details/:id'
            element={<LayoutPages.CourierDetail pageTitle='Детали курьера' />}
          />
          <Route
            path='courier/update/:id'
            element={<LayoutPages.UpdateCourier pageTitle='Редактирование курьера' />}
          />

          <Route
            path='agent/add'
            element={<LayoutPages.AddAgent pageTitle='Добавление агента' />}
          />
          <Route
            path='agents'
            element={<LayoutPages.Agents pageTitle='Список агентов' />}
          />
          <Route
            path='agent/details/:id'
            element={<LayoutPages.AgentDetail pageTitle='Детали агента' />}
          />
          <Route
            path='agent/update/:id'
            element={<LayoutPages.AgentEdit pageTitle='Редактирование агента' />}
          />

          <Route
            path='courierTransaction'
            element={<LayoutPages.CouriersTransaction pageTitle='Список транзакций (курьеры)' />}
          />

          <Route
            path='courierTransactionTest'
            element={<LayoutPages.CouriersTransactionTest pageTitle='Список транзакций (курьеры) 2' />}
          />

          <Route
            path='transaction'
            element={<LayoutPages.Transaction pageTitle='Список транзакций' />}
          />
          <Route
            path='transaction/update/:id'
            element={<LayoutPages.TransactionUpdate pageTitle='Редактирование транзакциb' />}
          />
          {/* <Route
            path='bank'
            element={<LayoutPages.KassaCategory pageTitle='Банк и касса' />}
          />

          <Route
            path='bank/:kassaID'
            element={<LayoutPages.KassaCategoryDetail pageTitle='Список касс' />}
          /> */}
          <Route
            path='kassa'
            element={<LayoutPages.Kassa pageTitle='Список касс' />}
          />
          <Route
            path='kassa/details/:id'
            element={<LayoutPages.KassaDetails pageTitle='Детали кассы' />}
          />
          <Route
            path='kassa/add'
            element={<LayoutPages.AddKassa pageTitle='Добавить кассу' />}
          />
          <Route
            path='kassa/update/:id'
            element={<LayoutPages.EditKassa pageTitle='Редактирование кассы' />}
          />
          <Route
            path='osv'
            element={<LayoutPages.OSV pageTitle='ОСВ' />}
          />
          <Route
            path='dailyReport'
            element={<LayoutPages.DailyReport pageTitle='Ежедневный отчет' />}
          />

          <Route
            path='cities'
            element={<LayoutPages.Cities pageTitle='Список городов' />}
          />
          <Route
            path='city/details/:id'
            element={<LayoutPages.CityDetail pageTitle='Детали города' />}
          />
          <Route
            path='cityOrdersCompleted'
            element={<LayoutPages.CityCompletedOrder pageTitle='Завершенные заказы (Город)' />}
          />
          <Route
            path='cityOrders'
            element={<LayoutPages.CityOrder pageTitle='Список заказов (Город)' />}
          />
          <Route
            path='cityOrder/add'
            element={<LayoutPages.AddCityOrder pageTitle='Добавить заказ (Город)' />}
          />
          <Route
            path='cityOrder/details/:id'
            element={<LayoutPages.CityOrderDetail pageTitle='Детали заказа (Город)' />}
          />
          <Route
            path='cityOrder/update/:id'
            element={<LayoutPages.EditCityOrder pageTitle='Редактирование заказа (Город)' />}
          />
          <Route
            path='cityOrder/history/:id'
            element={<LayoutPages.HistoryCity pageTitle='История заказа (Город)' />}
          />
          {/* <Route
            path='city/update/:id'
            element={<LayoutPages.CityUpdate pageTitle='Редактирование города' />}
          /> */}
          {/* <Route
            path='village/update/:id'
            element={<LayoutPages.VillageUpdate pageTitle='Редактирование района' />}
          /> */}
          <Route
            path='faq'
            element={<LayoutPages.FAQ pageTitle='Часто задаваемые вопросы' />}
          />
          <Route
            path='stores'
            element={<LayoutPages.Stores pageTitle='Магазины' />}
          />
          <Route
            path='stores/:id'
            element={<LayoutPages.StoreDetail pageTitle='Детали магазина' />}
          />
          <Route
            path='storeOrders/:id'
            element={<LayoutPages.StoreOrderDetail pageTitle='Детали заказа магазина' />}
          />
          <Route
            path='categories'
            element={<LayoutPages.Categories pageTitle='Категории' />}
          />
          <Route
            path='categories/:id'
            element={<LayoutPages.EditCategory pageTitle='Редактирование категории' />}
          />
          <Route
            path='categories/add'
            element={<LayoutPages.AddCategory pageTitle='Добавить категорию' />}
          />
          <Route
            path='subCategories'
            element={<LayoutPages.SubCategories pageTitle='Подкатегории' />}
          />
          <Route
            path='subCategories/:id'
            element={<LayoutPages.EditSubCategory pageTitle='Редактирование подкатегории' />}
          />
          <Route
            path='subCategories/add'
            element={<LayoutPages.AddSubCategory pageTitle='Добавить подкатегорию' />}
          />
          <Route
            path='subSubCategories'
            element={<LayoutPages.SubSubCategories pageTitle='Подподкатегории' />}
          />
          <Route
            path='subSubCategories/add'
            element={<LayoutPages.AddSubSubCategory pageTitle='Добавить подподкатегорию' />}
          />
          <Route
            path='subSubCategories/:id'
            element={<LayoutPages.EditSubSubCategory pageTitle='Редактирование подподкатегории' />}
          />
          <Route
            path='colors'
            element={<LayoutPages.Colors pageTitle='Цвета' />}
          />
          <Route
            path='colors/add'
            element={<LayoutPages.AddColor pageTitle='Добавить цвет' />}
          />
          <Route
            path='colors/:id'
            element={<LayoutPages.EditColor pageTitle='Редактирование цвета' />}
          />
          <Route
            path='sizes'
            element={<LayoutPages.MarketPlaceSize pageTitle='Размеры' />}
          />
          <Route
            path='sizes/add'
            element={<LayoutPages.AddSize pageTitle='Добавить размер' />}
          />
          <Route
            path='sizes/:id'
            element={<LayoutPages.EditSize pageTitle='Редактирование размера' />}
          />
          <Route
            path='brands'
            element={<LayoutPages.MarketPlaceBrands pageTitle='Бренды' />}
          />
          <Route
            path='brands/add'
            element={<LayoutPages.AddBrand pageTitle='Добавить бренд' />}
          />
          <Route
            path='brands/:id'
            element={<LayoutPages.EditBrand pageTitle='Редактирование бренда' />}
          />
          <Route
            path='brands/add'
            element={<LayoutPages.AddBrand pageTitle='Добавить бренд' />}
          />
          <Route
            path='*'
            element={<LayoutPages.NotFound />}
          />
        </Routes>

      </div>
    </>
  );
};

export default PrivateRoutes;

